export const ALL_ITEMS = 'ALL_ITEMS';
export const ALERTS = 'ALERTS';
export const INVENTORY = 'INVENTORY';
export const BASE = 'BASE';

export const PRIVATE = 'PRIVATE';
export const PUBLIC = 'PUBLIC';
